<template>
  <div>
    <el-dialog title="Məsul şəxs" :visible.sync="showModal" width="30%" top="30vh" append-to-body
      :close-on-press-escape="false" :close-on-click-modal="false">
      <tech-expert-users v-model="item.techExpertUid" />
      <span slot="footer" class="dialog-footer">
        <el-button  size="small" @click="showModal = false">{{$t('İmtina')}}</el-button>
        <el-button  size="small" type="primary" @click="clickSave">{{$t('Yadda_saxla')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TechExpertUsers from "../components/TechExpertUsers.vue";
import { TechExpertUserUpdate } from "../../services/claim";
export default {
  components: {
    TechExpertUsers,
  },
  data() {
    return {
      showModal: false,
      item: {},
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    edit(item) {
      this.item = item;
      this.showModal = true;
    },
    clickSave() {
      TechExpertUserUpdate(this.item.id, this.item.techExpertUid, this.uid).then(
        (response) => {
          if (response.data.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat"
                  ? "Səhv əməliyyat"
                  : "Səhv əməliyyat",
              });
            } else {
              this.$emit("refresh-table");
              this.showModal = false;
              this.$message({
                type: "success",
                message: "Uğurlu əməliyyat",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "Səhv əməliyyat",
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>

</style>
